module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div>\r\n    <button type="button" class="btn btn-primary" id="scroll-to-add">Add new comment</button>\r\n</div>\r\n\r\n<div class="top-margined bottom-margined">\r\n    <div class="list-of-comments" style="max-height: 2000px;"></div>\r\n</div>\r\n\r\n<div id="confirmation-modal"></div>';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/templates/comments/comments-table.html
// module id = 271
// module chunks = 0